import { BreadcrumbItem } from 'types';
import React, { createContext, ReactNode, useContext, useReducer } from 'react';

interface UseLayoutState {
  breadcrumbs: BreadcrumbItem[] | undefined;
}

export type LayoutActions = {
  type: 'SET_BREADCRUMBS';
  breadcrumbs: BreadcrumbItem[];
};
type Dispatch = (action: LayoutActions) => void;

export const layoutReducer = (
  state: UseLayoutState,
  action: LayoutActions,
): UseLayoutState => {
  switch (action.type) {
    case 'SET_BREADCRUMBS': {
      const { breadcrumbs } = action;
      return { ...state, breadcrumbs };
    }
    default: {
      return state;
    }
  }
};

const LayoutStateContext = createContext<
  { state: UseLayoutState; dispatch: Dispatch } | undefined
>(undefined);

interface LayoutProviderProps {
  children: ReactNode;
  reducerInitialState?: UseLayoutState;
}

export function LayoutProvider(props: LayoutProviderProps) {
  const { children, reducerInitialState } = props;
  const initialState = reducerInitialState ?? { breadcrumbs: undefined };
  const [state, dispatch] = useReducer(layoutReducer, initialState);

  const value = { state, dispatch };

  return (
    <LayoutStateContext.Provider value={value}>{children}</LayoutStateContext.Provider>
  );
}

export function useLayoutState() {
  const context = useContext(LayoutStateContext);
  if (!context) throw new Error('useLayoutState must be used within a LayoutProvider');
  return context;
}
